const setExpanded = (toggle, expanded) => {
    toggle.setAttribute("aria-expanded", String(expanded));
    const children = document.getElementById(toggle.getAttribute("aria-controls"));
    if (children) children.hidden = !expanded;
};

// Toggle clicks are handled in the capture phase with propagation stopped:
// nested-menu attaches a click handler on each top-level nav row that treats
// any bubbled click inside the panel as a row activation and closes the open
// mega menu (suppressed in the theme editor, live on the storefront).
document.addEventListener("click", (event) => {
    const toggle = event.target.closest(".js-mega-children-toggle");
    if (!toggle) return;
    event.stopPropagation();
    setExpanded(toggle, toggle.getAttribute("aria-expanded") !== "true");
}, true);

// "toggle" does not bubble, so listen in the capture phase; collapse any
// expanded 4th-tier groups whenever their mega menu panel closes.
document.addEventListener("toggle", (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || details.open) return;
    if (!details.closest("header-details-disclosure.mega")) return;
    details.querySelectorAll('.js-mega-children-toggle[aria-expanded="true"]').forEach((toggle) => {
        setExpanded(toggle, false);
    });
}, true);
